// import {v4 as uuidv4} from 'uuid';

export default class File {
    constructor(serverUuid, tmpUuid, name, ext, size, mimeType) {
        this.serverUuid = serverUuid;
        this.tmpUuid = tmpUuid;
        this.name = name;
        this.ext = ext;
        this.size = size;
        this.mimeType = mimeType;
        this.thumbnailUrl = null;

        this.dataURL = null;
        this.isFetchingInfo = false;
        this.isDownloading = false;
        this.isBusy = false;
        this.busyMessage = '';

        this.displayClasses = [];
    }

    isImage() {
        return (this.mimeType || '').includes('image');
    }

    getTitle() {
        return this.name.concat('.', this.ext);
    }

    busyOn(msg) {
        this.isBusy = true;
        this.busyMessage = msg || '';
    }

    busyOff() {
        this.isBusy = false;
        this.busyMessage = '';
    }
    
    addCssClass(className) {
        this.displayClasses.push(className);
    }

    removeCssClass(className) {
        this.displayClasses = this.displayClasses.filter(cl => cl !== className);
    }
}